import { reactive } from 'vue'

const LANGUAGE_STORAGE_KEY = 'appLanguage'

export const languageOptions = [
  { key: 'en', label: 'English' },
  { key: 'zh', label: '中文' },
]

function getInitialLanguage() {
  if (typeof window === 'undefined') {
    return 'en'
  }

  const saved = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (saved === 'en' || saved === 'zh') {
    return saved
  }

  const browserLanguage = (window.navigator.language || '').toLowerCase()
  return browserLanguage.startsWith('zh') ? 'zh' : 'en'
}

export const languageState = reactive({
  value: getInitialLanguage(),
})

export function setLanguage(language) {
  if (language !== 'en' && language !== 'zh') {
    return
  }

  languageState.value = language
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  }
}

export function getInstructionImageSrc(language = languageState.value) {
  return language === 'zh' ? '/instruction_Chinese.png' : '/instruction.png'
}
